module.exports = __webpack_public_path__ + "static/media/uxuyConnectIcon.314c92ba.svg";